const ChevDown = () => {
    return (
        <div className="py-10">    
            <svg className="w-14 h-14 cursor-pointer text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.5" d="M19 9l-7 7-7-7"></path>
            </svg>
        </div>
    );
};

export default ChevDown;
